import React from "react"

const withFormBindings = WrappedComponent => props => { 
  const { form, id, ...otherProps } = props
  return <WrappedComponent id={`${form}_${id}`} name={`${form}[${id}]`} {...otherProps} />
}

export default withFormBindings